/**
 * ReviewsTab Component
 * Program reviews and ratings
 */

import React from 'react';
import { FaThumbsUp, FaThumbsDown } from 'react-icons/fa';
import styles from './TabStyles.module.css';

const ReviewsTab = ({ program }) => {
  const reviews = program?.reviews || [];

  return (
    <div className={styles.tabContainer}>
      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Reviews</h3>
        
        <div className={styles.reviewList}>
          {reviews.length > 0 ? (
            reviews.map((review, index) => (
              <div key={index} className={styles.reviewItem}>
                <div className={styles.reviewHeader}>
                  <div className={styles.reviewRating}>
                    {review.rating === 'positive' || review.recommended ? (
                      <FaThumbsUp className={styles.thumbsUp} />
                    ) : (
                      <FaThumbsDown className={styles.thumbsDown} />
                    )}
                  </div>
                  <span className={styles.reviewerName}>
                    {review.reviewer || review.userName || 'Anonymous'}
                  </span>
                  <span className={styles.reviewDate}>
                    {review.date 
                      ? new Date(review.date).toLocaleDateString() 
                      : ''}
                  </span>
                </div>
                {review.feedback && (
                  <p className={styles.reviewFeedback}>{review.feedback}</p>
                )}
              </div>
            ))
          ) : (
            <p className={styles.emptyMessage}>No reviews yet. Be the first to leave a review!</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default ReviewsTab;









